import { Fragment, type ReactNode } from 'react'

type ParaglideMFunction<TInputs, TOptions> = (
  inputs: TInputs,
  options?: TOptions,
) => string

export function InterpolatedMessage<
  TInputs extends Record<string, ReactNode>,
  TOptions,
>(props: { message: ParaglideMFunction<TInputs, TOptions>; inputs: TInputs }) {
  const string = props.message(
    Object.fromEntries(
      Object.keys(props.inputs ?? {}).map((key) => [key, `{${key}}`]),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as any,
  )
  const args = props.inputs

  if (!args) return string

  const parts: ReactNode[] = []
  let lastIndex = 0

  const pattern = /{([^}]+)}/g
  let match: RegExpExecArray | null

  while ((match = pattern.exec(string)) !== null) {
    const [fullMatch, key] = match
    const value = args[key.trim()]

    if (match.index > lastIndex) {
      parts.push(string.slice(lastIndex, match.index))
    }

    if (value !== undefined) {
      parts.push(<Fragment key={match.index}>{value}</Fragment>)
    } else {
      parts.push(fullMatch)
    }

    lastIndex = match.index + fullMatch.length
  }

  if (lastIndex < string.length) {
    parts.push(string.slice(lastIndex))
  }

  if (parts.length === 0) return string

  return parts
}
